import PropTypes from 'prop-types';

import StockStatus from 'components/product_show/stock_status';

const DeliveryStock = ({
  deliveryStock,
  deliveryStockEta,
  specialOrderMessage,
  isCollectionOnly,
}) => {
  const outOfStock =
    isCollectionOnly || specialOrderMessage || !(deliveryStock > 0);

  const renderText = () => {
    if (isCollectionOnly) return '';
    if (specialOrderMessage) return specialOrderMessage;

    if (deliveryStock > 0) {
      return (
        <>
          <span
            className="tc-cef-green fw-700"
            data-testid="product-actions__delivery-stock">
            {deliveryStock}
          </span>{' '}
          in stock for delivery
        </>
      );
    }

    if (deliveryStockEta) {
      return 'Out of stock for delivery';
    }

    return 'Unknown delivery date';
  };

  return (
    <div>
      <StockStatus outOfStock={outOfStock}>{renderText()}</StockStatus>
      {deliveryStockEta && outOfStock && (
        <p className="fs-12 m-0 ml-14 mt-6 mb-0">
          Available from{' '}
          <span className="tc-cef-green fw-700">{deliveryStockEta}</span>
        </p>
      )}
    </div>
  );
};

DeliveryStock.propTypes = {
  deliveryStock: PropTypes.number,
  deliveryStockEta: PropTypes.string,
  specialOrderMessage: PropTypes.string,
  isCollectionOnly: PropTypes.bool,
};

export default DeliveryStock;
